import { Controller, Payload } from "../../controller";
import { ApplicationState } from "../../store";
import { bindActionCreators, Dispatch} from "redux";
import { action } from "typesafe-actions";

import { Funcionario ,initialValueState, FuncionarioState, FuncionarioActions } from "./funcionario.model"
import { put, takeLatest } from "redux-saga/effects";
import { log } from "console";
import { canalDistController } from "../canalDist/canalDist.controll";

export interface FuncionarioViewProps{
    funcionarioState:FuncionarioState
    funcionarioActions:FuncionarioActions
}


class FuncionarioController extends Controller<Funcionario, FuncionarioState, FuncionarioActions> {
    constructor() {
        super(initialValueState.row.type,initialValueState);

        this.actionsType = {
            ...this.actionsType,
            //inserir aqui os novos actionsTypes
            setFuncLogado: `@${this.moduloName}/SET_FUNC_LOGADO`,
            logout: `@${this.moduloName}/LOGOUT`,
        };

        this.reducer.actions = {
            ...this.reducer.actions,
            //inserir aqui os novos actions
            setFuncLogado: (func)=>action(this.actionsType.setFuncLogado, { func , this:this}),
            logout: ()=>action(this.actionsType.logout, {  this:this}),
        }

        this.actionEffects = [
            ...this.actionEffects,
            //inserir aqui os novos Effects
            takeLatest(this.actionsType.setFuncLogado, this.setFuncLogadoEffects),
            takeLatest(this.actionsType.logout, this.logoutEffects),
        ]
    }

    private* setFuncLogadoEffects(actions:Payload){
        const self = actions.payload.this as FuncionarioController
        try {
            const func:Funcionario = actions.payload.func
            
            localStorage.setItem("funcionario", JSON.stringify(func));

            yield put(self.reducer.resultAfterEffects({
                ...self.state, funcLogado:func
            },self.actionsType.setFuncLogado))

        } catch (error:any) {
            console.log("error setFuncLogadoEffects", error);
            let msg = "Ops, ocorreu uma falha em setFiltroEffect, detalhes: ";
            let err = msg + (typeof error === 'object' ? JSON.stringify(error) : error);
            yield put(self.reducer.resultAfterEffects(
                { ...self.state,  msg: err, status: "error", error: true, showAlert: true },
                self.actionsType.setFuncLogado
            ))
        }
    }

    private* logoutEffects(actions:Payload){
        const self = actions.payload.this as FuncionarioController
        try {
            localStorage.removeItem("funcionario");

            yield put(self.reducer.resultAfterEffects({
                ...self.state, funcLogado:initialValueState.funcLogado, showSelectModal:true
            },self.actionsType.logout))


        } catch (error:any) {
            console.log("error logoutEffects", error);
            let msg = "Ops, ocorreu uma falha em logoutEffects, detalhes: ";
            let err = msg + (typeof error === 'object' ? JSON.stringify(error) : error);
            yield put(self.reducer.resultAfterEffects(
                { ...self.state,  msg: err, status: "error", error: true, showAlert: true },
                self.actionsType.logout
            ))
        }
    }   
}

export const funcionarioController = new FuncionarioController()

export const mapStateToFuncionarioProps = (state: ApplicationState) => ({
    funcionarioState: state.funcionarioState,
})

export const mapDispatchToFuncionarioProps = (dispatch: Dispatch) => ({
    funcionarioActions: bindActionCreators({...funcionarioController.reducer.actions}, dispatch),
})